var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreenExitLine = function SvgFullscreenExitLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.9 7.498h3.6v1.8h-5.4v-5.4h1.8zm-9 1.8H3.5v-1.8h3.6v-3.6h1.8zm9 7.2v3.6h-1.8v-5.4h5.4v1.8zm-9-1.8v5.4H7.1v-3.6H3.5v-1.8z"
  })));
};
export default SvgFullscreenExitLine;